import axios from "axios";
import config from "@Config/index";

/**
 * All active tenancies of one room type (page filters not applied). Used by the room details modal
 * and the room details side panel.
 */
const fetchRoomActiveChildren = async (
  roomId: number | string,
  { userCurrency, userLanguage }: { userCurrency?: string; userLanguage?: string },
): Promise<any[]> => {
  const response = await axios.get(`${config.API_URL}/api/v0/inventories/${roomId}`, {
    params: {
      type: "empty",
      only: "id",
      methods: "active_children",
      user_currency: userCurrency,
      lang: userLanguage || "en",
      use_java_api: true,
    },
    headers: { "X-Use-Java-Api": "true" },
  });
  return response?.data?.data?.active_children || [];
};

export default fetchRoomActiveChildren;
